export default __webpack_public_path__ + "static/media/x.063ed1e5.svg";